import Axios from 'axios'
import {
    message
} from 'ant-design-vue'
import {
    getUrlParam
} from '@/utils/util'
import store from "../store/index";
import $router from '../router/index.js'
import Vue from 'vue'
const axios = Axios.create({
    // 测试
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 10000,
    headers: {
        'X-Access-Token': localStorage.getItem('token'),
        'content-type': 'application/json',
        'tenantName': 'master',
    }
})

// 前置拦截器（发起请求之前的拦截）
axios.interceptors.request.use(
        config => {
            config.headers['X-Access-Token'] = localStorage.getItem('token')
            return config
        },
        error => {
            return Promise.reject(error)
        }
    )
    // 后置拦截器（获取到响应时的拦截）
axios.interceptors.response.use(
    response => {
        let $store = Vue.prototype.$store
        if (response.status == 200) {
            if ([0, 200].includes(response.data.code)) {
                return response.data
            } else if (response.data.code == 990007) {
                message.error('请重新登录！')
                localStorage.setItem('token', '')
                location.href = `${process.env.VUE_APP_LOGIN_BASE_URL}` //跳登录
            } else if ([990008, 990009, 990010, 990012, 990011].includes(response.data.code)) {
                // 如果在登录页面，不进行全局弹窗和跳转，交由页面自行处理
                if ($router.history.current.path === '/login') {
                    // message.error(response.data.message || '登录异常，请联系管理员');
                } else {
                    if (response.data.code == 990011) {
                        $store.commit('SET_TOAST', '登录失败，该客户账号已冻结，请联系管理员！')
                            // 您选择登录的企业微信尚未开通Weiit应用或尚未在Weiit应用中配置企业微信应用信息，请联系企业微信管理员！
                    } else {
                        $store.commit('SET_TOAST', '登录失败，该客户账号无访问权限，请联系管理员！')
                            // 您的企业微信账号没有访问Weiit应用的权限，无法登录Weiit应用系统，请联系企业微信管理员！
                    }
                    $router.push('/error')
                }
            } else {
                let currentPage = $router.history.current
                let currentCode = response.data.code
                if (currentCode == 500 && currentPage.path == "/loading") {
                    $store.commit('SET_500_TOAST', response.data.message)
                    $router.push('/error500')
                } else {
                    // 如果是登录页面，且是业务错误（如密码错误），屏蔽全局弹窗
                    if (currentPage.path === '/login') {
                        // pass
                    } else {
                        message.error(response.data.message)
                    }
                }
            }

        } else {
            if (response.status == 990007) {
                message.error('请重新登录！')
                localStorage.setItem('token', '')
                location.href = `${process.env.VUE_APP_LOGIN_BASE_URL}` //跳登录
            } else {
                message.error('请求异常！')
            }

        }
        return response.data
    },
    error => {
        throw error
            // return Promise.reject(error)
    }
)
export default axios